const borderRadius = '0.28571429rem';

export default borderRadius;
